import * as React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Scroller from '@/components/ui/Scroller';

export interface IListMissionsProps {
  children?: React.ReactNode;
  layout?: 'default' | 'horizontal' | 'mobile-compact';
  limited?: boolean;
}

const ListMissions: React.FunctionComponent<IListMissionsProps> = (props) => {
  if (props.layout === 'horizontal' || props.layout === 'mobile-compact') {
    return (
      <Scroller
        showArrows={true}
        showDots={true}
      >
        <ul
          className={classNames(styles['list-missions'], styles['layout-horizontal'], {
            [styles['layout-mobile-compact']]: props.layout === 'mobile-compact',
          })}
        >
          {props.children}
        </ul>
      </Scroller>
    );
  }

  return (
    <ul
      className={classNames(styles['list-missions'], styles['layout-default'], {
        [styles['limited']]: props.limited,
      })}
    >
      {props.children}
    </ul>
  );
};

ListMissions.displayName = 'ListMissions';

export default ListMissions;
